import { Subscription } from 'rxjs';
import { StudentHelperService } from './../service/student-helper.service';
import { JoinPipe } from './../../../pipes/join.pipe';
import { StudentSchoolEnrollmentService } from './../service/student-school-enrollment.service';
import { AccessService } from 'src/app/component/navigation/service/access.service';
import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { SearchStudent } from '../model/searchStudent';
import { EditChildDemographicComponent } from './edit-child-demographic/edit-child-demographic.component';
import Swal from 'sweetalert2';
import { MatTab, MatTabGroup, MatTabHeader } from '@angular/material/tabs';
import { SchoolEnrollment } from '../model/school-enrollment.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'edit-child',
    templateUrl: './edit-child.component.html',
    styleUrls: ['./edit-child.component.scss']
})
export class EditChildComponent implements OnInit {
    @Input() studentId!: number;
    @Output() editingTabChange: EventEmitter<string> = new EventEmitter<string>();
    @ViewChild('tabs') tabs: MatTabGroup;
    studentName: string = '';
    msdNumber: string = '';
    regions: string = '';
    merged: string = '';
    isMerged: boolean = false;
    currentTab: string = 'Demographic';
    partyId!: number;
    title: string = '';
    terminated: string = '';

    featuresCheck: string[] = [   
        'View Students',     
        'Edit Students',       
        'Edit Student Demographics',
        'Edit Student Contact Information',
        'Edit Student School Enrollments',
        'Edit Student Services',
        'Edit Communication Events',                
        'Edit Course Histories',                        
        'Edit INA/ILP'        
    ];
    featurePermissions: any;

    editableTabs: any = {
        Demographic: false,
        'Address Info': false,
        'Enrollment Info': false,
        'Eligibility Status': false,
        'Move History': false,
        'Service Participation': false,
        'Communication Events': false,
        'Course History': false,
        'INA/ILP': false
    };

    editing: boolean = false;

    joinPipe: JoinPipe = new JoinPipe();

    promises: any[] = [];
    isLoading: boolean = true;

    subs: Subscription[] = [];

    @ViewChild('editChildDemographic') EditChildDemographicComponent: EditChildDemographicComponent;

    constructor(
        private route: ActivatedRoute,
        private studentHelper: StudentHelperService,
        public accessService: AccessService
    ) {
        this.subscriptions();
    }

    subscriptions() {
        let studentNameSub = this.studentHelper.studentName$.subscribe((studentName) => {
            this.studentName = studentName;
        });

        this.subs.push(studentNameSub);

        let regionsSub = this.studentHelper.regions$.subscribe((regions) => {
            this.regions = regions;
        });

        this.subs.push(regionsSub);

        let mergedSub = this.studentHelper.merged$.subscribe((merged) => {
            this.merged = merged;
        });

        this.subs.push(mergedSub);

        let isMergedSub = this.studentHelper.isMerged$.subscribe((isMerged) => {
            this.isMerged = isMerged;
        });

        this.subs.push(isMergedSub);

        let msdNumberSub = this.studentHelper.msdNumber$.subscribe((msdNumber) => {
            this.msdNumber = msdNumber;
        });

        this.subs.push(msdNumberSub);

        let terminatedSub = this.studentHelper.terminated$.subscribe((terminated) => {
            this.terminated = terminated;
        });

        this.subs.push(terminatedSub);
    }

    ngOnDestroy(): void {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    ngOnInit(): void {
        this.isLoading = true;
        this.getFeaturePermissions();

        /*this.accessService.nonRegionalUser().subscribe((x) => {
            if (x) {
                
                this.editableTabs['Communication Events'] = true;
                this.editableTabs['INA/ILP'] = true;
            }
        });*/

        // Laks comments  --https://www.syncfusion.com/blogs/post/angular-promises-versus-observables.aspx
        /*Often Observable is preferred over Promise because it provides the features of Promise and more. 
		With Observable it doesn't matter if you want to handle 0, 1, or multiple events. 
		You can utilize the same API in each case. 
		Observable also has the advantage over Promise to be cancellable. */
        
        
        
        
        
        
               
        Promise.all(this.promises).then((res) => {
            if (this.featurePermissions['Edit Student Demographics']) {
                this.editableTabs['Demographic'] = true;
            }            
            if (this.featurePermissions['Edit Student Contact Information']) {
                this.editableTabs['Address Info'] = true;
            }                        
            if (this.featurePermissions['Edit Student School Enrollments']) {
                this.editableTabs['Enrollment Info'] = true;
            }                        
            if (this.featurePermissions['Edit Student Services']) {
                this.editableTabs['Service Participation'] = true;
            }                                                
            if (this.featurePermissions['Edit Communication Events']) {
                this.editableTabs['Communication Events'] = true;
            }
            if (this.featurePermissions['Edit INA/ILP']) {
                this.editableTabs['INA/ILP'] = true;
            }
            if (this.featurePermissions['Edit Course Histories']) {
                this.editableTabs['Course History'] = true;
            }
            
            if (this.featurePermissions['View Students']) {
                if (!this.studentId) {
                    const studentIdParam = this.route.snapshot.paramMap.get('studentId');
                    if (studentIdParam && parseInt(studentIdParam)) {
                        this.studentId = parseInt(studentIdParam);
                    }
                }
            }

            this.studentHelper.setStudentId(this.studentId);

            //this.getSchoolEnrollments();
            this.isLoading = false;

            setTimeout(() => {
                this.tabs._handleClick = this.interceptTabChange.bind(this);
            });
        });
    }

    getFeaturePermissions() {
        let deferred = new Promise((resolve, reject) => {
            this.accessService.getFeatureAccessPromise(this.featuresCheck).then((res) => {
                this.featurePermissions = res;
                resolve(res);
            });
        });
        this.promises.push(deferred);
    }

    toggleEdit() {
        this.editing = !this.editing;
        if (this.editing) {
            this.editingTabChange.emit(this.currentTab);
        } else {
            this.editingTabChange.emit('');
        }
    }

    editingChange(editing: boolean) {
        this.editing = editing;
        if (this.editing) {
            this.editingTabChange.emit(this.currentTab);
        } else {
            this.editingTabChange.emit('');
        }
    }

    interceptTabChange(tab: MatTab, tabHeader: MatTabHeader, idx: number) {
        if (this.editing) {
            Swal.fire({
                titleText: 'Unsaved changes will be lost. Continue?',
                html: '<b>You are currently editing:</b> <br /><br />' + this.currentTab,
                showDenyButton: false,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Continue',
                cancelButtonText: 'Go Back',
                icon: 'warning',
                confirmButtonColor: '#3a6b35'
            }).then((result: any) => {
                if (result.isConfirmed) {
                    this.editing = false;
                    this.currentTab = tab.textLabel;
                    return MatTabGroup.prototype._handleClick.apply(this.tabs, [tab, tabHeader, idx]);
                }
            });
        } else {
            this.currentTab = tab.textLabel;
            return MatTabGroup.prototype._handleClick.apply(this.tabs, [tab, tabHeader, idx]);
        }
    }
}
